/**
 * scanQuotaApi.ts - quota de scans du tenant (selon le plan d'abonnement).
 * Pilote l'affichage et la désactivation des boutons de scan (M365 / Azure).
 */
import { apiFetch } from './apiClient';

export interface ScanQuotaScope {
  scope:         'm365' | 'azure';
  tier:          string;   // free | starter | pro | business | enterprise
  allowed:       boolean;
  azureDisabled: boolean;  // true = Azure indisponible sur ce plan (gratuit)
  unlimited:     boolean;
  limit:         number;   // scans autorisés par fenêtre (0 si illimité)
  windowDays:    number;   // 7 ou 30
  used:          number;
  remaining:     number | null;
  bonus:         number;
  fromBonus:     boolean;
  nextAllowedAt: string | null;  // ISO — prochaine date possible si bloqué
  reason:        string;
}

export interface ScanQuota {
  plan:  string;
  bonus: number;
  m365:  ScanQuotaScope;
  azure: ScanQuotaScope;
}

export const scanQuotaApi = {
  // Route distincte de /scans/{id} pour éviter toute collision de routing.
  get: () => apiFetch<ScanQuota>('/scan-quota'),
};
